var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.35156 2.16748H6.78125V4.35498H10.6094L9.76172 2.44092C9.67969 2.27686 9.51562 2.16748 9.35156 2.16748ZM10.9375 5.66748H1.3125V11.355C1.3125 11.6011 1.50391 11.7925 1.75 11.7925H10.5C10.7188 11.7925 10.9375 11.6011 10.9375 11.355V5.66748ZM1.61328 4.35498H5.46875V2.16748H2.87109C2.70703 2.16748 2.54297 2.27686 2.48828 2.44092L1.61328 4.35498ZM9.35156 0.85498C10.0352 0.85498 10.6641 1.26514 10.9375 1.89404L12.0859 4.46436C12.1953 4.68311 12.25 4.9292 12.25 5.17529V11.355C12.25 12.3394 11.457 13.105 10.5 13.105H1.75C0.765625 13.105 0 12.3394 0 11.355V5.17529C0 4.9292 0.0273438 4.68311 0.136719 4.46436L1.28516 1.89404C1.55859 1.26514 2.1875 0.85498 2.87109 0.85498H9.35156Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.0d3d7e99e79f4363fd08b63d944c2aa6.svg";
export { ForwardRef as ReactComponent };